import React, { useState, useEffect } from 'react'
import Load from "../Load/Load"
import { getClinics, deleteClinic } from '../../Web Apis/webApis'
import { message, Pagination } from 'antd'
import { AiFillDelete, AiFillEdit, AiOutlineEye } from "react-icons/ai";

import AddClinic from './AddClinic';
import EditClinic from './EditClinic';

const Clinic = () => {
    const [loading, setLoading] = useState(false)
    const [allClinics, setAllClinics] = useState([])
    const [action, setAction] = useState(false)


    const [showAddModal, setShowAddModal] = useState(false)
    const [showViewModal, setShowViewModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)

    const [selectedClinic, setSelectedClinic] = useState({})

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // Calculate the current items for the page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = allClinics.slice(indexOfFirstItem, indexOfLastItem);

    const fetchClinicDetails = async () => {

        try {
            setLoading(true)

            const response = await getClinics()
            console.log("repsaonse", response)

            if (response?.data?.success) {
                setAllClinics(response?.data?.data)
            }

        } catch (error) {
            console.error("Error fetching clinic details", error);
            if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
                // Handle internet disconnection
                return;
            }
            // Handle specific error cases
            if (error?.response?.status === 401) {
                window.alert("Your account is logged in to another device, please login again !")
                localStorage.removeItem('token');
                // setIsAuthenticated(false)
                window.location.href = "/login";
            }
            if (error?.response?.status === 500) {
                message.error("Server not responding")
                return;
            }

            else {

                return;
            }
        } finally {
            setLoading(false)
        }
    }



    useEffect(() => {
        fetchClinicDetails()
    }, [action])


    const handleCreateModalOpen = () => {
        setShowAddModal(true)
    }

    const handleDetailsModalOpen = () => {

    }

    const handleUpdateModalOpen = (item) => {
        setSelectedClinic(item)
        setShowEditModal(true)
    }

    const handleDeleteModalOpen = (item) => {
        setSelectedClinic(item)
        setShowDeleteModal(true)
    }


    const deleteClinicDetails = async () => {
        if (!selectedClinic) return;
        try {
            setLoading(true)

            const response = await deleteClinic(selectedClinic.id)
            if (response?.data?.success) {
                message.success(response?.data?.message)
                setAction(!action);

                setShowDeleteModal(false)
            }



        } catch (error) {
            console.log("Error while delete clinic profile", error.message)
            message.error(error?.response?.data?.message || "Error while delete clinic details")

        } finally {
            setLoading(false)
        }
    }

    return (
        <div className='p-4 mt-16'>

            <div className="flex justify-between items-center w-full space-x-4">

                {/* Search Input Container */}
                <div className="relative flex items-center w-1/4">
                    <h2 className='text-3xl font-bold'>Clinic Management</h2>

                </div>


                {/* Create Button */}
                <button
                    onClick={handleCreateModalOpen}
                    className="bg-gradient-to-br from-teal-500 to-gray-500 hover:bg-blue-700 text-white font-bold py-2 px-8 rounded"
                >
                    Add Clinic
                </button>
            </div>



            <div>
                <table className='min-w-full mt-7 bg-gradient-to-br from-teal-600 to-teal-200 border border-b-4 border-black'>
                    <thead>
                        <tr>
                            <th className="py-2 px-4 border-b text-center">S.No</th>
                            <th className="py-2 px-4 border-b text-center">Clinic Name</th>
                            <th className="py-2 px-4 border-b text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>

                        {currentItems?.length > 0 ? (
                            currentItems?.map((items, index) => (
                                <tr key={items.id}
                                    className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
                                >
                                    <td className='py-2 px-4 border-b'>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                    <td className="py-2 px-4 border-b">{items.clinicName}</td>

                                    <td className="py-2 px-4 border-b">
                                        <div className="flex flex-row justify-center">
                                            {/* <button
                                                onClick={() => handleDetailsModalOpen(items)}
                                                className="text-blue-500 hover:text-blue-700 flex items-center"
                                            >
                                                <AiOutlineEye className="mr-1 text-2xl " />
                                            </button> */}
                                            <button
                                                onClick={() => handleUpdateModalOpen(items)}
                                                className="mr-2 text-blue-500 hover:text-blue-700 flex items-center"
                                            >
                                                <AiFillEdit className="mr-1 text-2xl" />
                                            </button>
                                            <button
                                                onClick={() => handleDeleteModalOpen(items)}
                                                className="text-red-500 hover:text-red-700 flex items-center"
                                            >
                                                <AiFillDelete className="mr-1 text-xl" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className=' px-4 py-4 border-b text-center font-bold'>No clinics data found</td>
                            </tr>
                        )}


                    </tbody>
                </table>
                {loading && <Load />}
            </div>

            <div className="mt-4 flex justify-end">
                <Pagination
                    current={currentPage}
                    total={allClinics.length}
                    pageSize={itemsPerPage}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                />
            </div>

            {showAddModal && (
                <AddClinic
                    showModal={showAddModal}
                    setShowModal={setShowAddModal}
                    action={action}
                    setAction={setAction}
                />
            )}
        
        {showEditModal && (
            <EditClinic
            showModal={showEditModal}
            setShowModal={setShowEditModal}
            action={action}
            setAction={setAction}
            selectedClinic={selectedClinic}
            />
        )}



            {showDeleteModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                        <h3 className="text-3xl font-bold mb-4 text-start">Confirm Delete</h3>
                        <p className="mb-4 text-start">Are you sure you want to delete this clinic details ? </p>
                        <div className="flex justify-end gap-4">
                            <button onClick={() => { setShowDeleteModal(false) }} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
                                Cancel
                            </button>
                            <button onClick={deleteClinicDetails} className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200">
                                Delete
                            </button>
                        </div>
                    </div>
                    {loading && <Load />}
                </div>
            )}

        </div>


    )
}

export default Clinic